import styled, { keyframes } from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 50px;
`;

export const LoaderContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50px;
  height: 50px;
  margin-top: -25px;
  margin-left: -25px;
`;

export const iosLoaderFade = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;

export const Bar = styled.div`
  position: absolute;
  top: 37%;
  left: 44.5%;
  opacity: 0;
  width: 10%;
  height: 26%;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  border-radius: 50px;
  background: ${({ theme }) => theme.colors.black};
  animation: ${iosLoaderFade} 1s linear infinite;
`;

export const Bar1 = styled(Bar)`
  transform: rotate(-315deg) translate(0, -142%);
  animation-delay: -0.875s;
`;

export const Bar2 = styled(Bar)`
  transform: rotate(-270deg) translate(0, -142%);
  animation-delay: -0.75s;
`;

export const Bar3 = styled(Bar)`
  transform: rotate(-225deg) translate(0, -142%);
  animation-delay: -0.625s;
`;

export const Bar4 = styled(Bar)`
  transform: rotate(-180deg) translate(0, -142%);
  animation-delay: -0.5s;
`;

export const Bar5 = styled(Bar)`
  transform: rotate(-135deg) translate(0, -142%);
  animation-delay: -0.375s;
`;

export const Bar6 = styled(Bar)`
  transform: rotate(-90deg) translate(0, -142%);
  animation-delay: -0.25s;
`;

export const Bar7 = styled(Bar)`
  transform: rotate(-45deg) translate(0, -142%);
  animation-delay: -0.125s;
`;

export const Bar8 = styled(Bar)`
  transform: rotate(0deg) translate(0, -142%);
  animation-delay: 0s;
`;

export const EmbedContainer = styled.div`
  width: 100%;
  height: 100%;

  .loader {
    width: 100%;
    height: 100%;
  }
`;
